
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M12.75 15.5h-.5a.25.25 0 0 1-.25-.25v-7.5a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v7.5a.25.25 0 0 1-.25.25zm-2.5 0h-.5a.25.25 0 0 1-.25-.25v-7.5a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v7.5a.25.25 0 0 1-.25.25zm-2.5 0h-.5a.25.25 0 0 1-.25-.25v-7.5a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v7.5a.25.25 0 0 1-.25.25zm7.25 2H5V5.25h10V17.5zM7.25 3.75h5.5V2.5h-5.5v1.25zM18 4a.25.25 0 0 0-.25-.25h-3.5V2.125c0-.621-.504-1.125-1.125-1.125h-6.25c-.622 0-1.125.504-1.125 1.125V3.75h-3.5A.25.25 0 0 0 2 4v1c0 .138.112.25.25.25H3.5v12.625c0 .622.503 1.125 1.125 1.125h10.75c.621 0 1.125-.503 1.125-1.125V5.25h1.25A.25.25 0 0 0 18 5V4z"}})])
          )
        }
      }
    